import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface NvEmptyStateProps {
  // The message (e.g. "북마크한 에이전트가 없어요.")
  children: ReactNode;
  // Optional next step under the message (a link-button such as "Agent Finder에서 찾아보기")
  action?: ReactNode;
  // card = bordered white box (My Page lists) · plain = text inside a panel or list that has its own frame
  variant?: "card" | "plain";
  // plain only: md = 15px secondary (Case Study list) · sm = 13px tertiary (HOME panels)
  size?: "md" | "sm";
  className?: string;
}

// Empty list / no result. Markup and dimensions are the ones the screens had hand-written
// (My Page `Empty`, Case Study list, HOME panels) — only the place they live changed.
export function NvEmptyState({ children, action, variant = "card", size = "md", className }: NvEmptyStateProps) {
  if (variant === "plain") {
    return (
      <p className={cn("py-20 text-center", size === "sm" ? "text-[13px] leading-4 text-nv-text-secondary" : "text-[15px] text-nv-text-secondary", className)}>
        {children}
      </p>
    );
  }
  return (
    <div className={cn("flex flex-col items-center gap-4 rounded-nv-card border border-nv-border bg-nv-surface px-10 py-16 text-center", className)}>
      <p className="text-[14px] leading-[22px] text-nv-text-secondary">{children}</p>
      {action}
    </div>
  );
}
